import styled from 'styled-components';

export const NoOverflowContainer = styled.div`
  max-width: 95%;
  word-break: break-word;
`;
